import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useRef, useState, } from 'react';
import { v4 as uuidv4 } from 'uuid';
const BKJPillSelectContext = createContext(null);
export const BKJPillSelectProvider = ({ children, value = [], onChange, name, max, }) => {
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    const mouseDownTargetRef = useRef(null);
    const [uuid] = useState(uuidv4());
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setFocus] = useState(false);
    const onInputFocused = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        inputRef.current?.focus();
        setFocus(true);
    }, []);
    const isMaxLimitReached = useMemo(() => value.length > max, [max, value.length]);
    const setNextValue = useCallback((nextValue) => {
        if (!nextValue)
            return;
        if (value.length >= max)
            return;
        onChange({ target: { name, value: nextValue } });
        setInputValue('');
    }, [max, name, onChange, value.length]);
    const onInputChange = useCallback((e) => {
        setNextValue(e.target.value);
        setFocus(false);
    }, [setNextValue]);
    const onChipRemove = useCallback((__VALUE__) => (event) => {
        event.preventDefault();
        event.stopPropagation();
        inputRef.current?.focus();
        setFocus(true);
        const index = value.indexOf(__VALUE__);
        const nextValue = Array.from(value);
        nextValue.splice(index, 1);
        onChange({ target: { name, value: nextValue } });
    }, [name, onChange, value]);
    const onInputBlur = useCallback((event) => {
        const containsTarget = event.currentTarget.contains(mouseDownTargetRef.current);
        if (containsTarget)
            event.stopPropagation();
        if (isFocused) {
            event.preventDefault();
            event.stopPropagation();
            setFocus(false);
        }
    }, [isFocused]);
    const onIsOpenChange = useCallback(({ isOpen }) => {
        if (!isOpen)
            setFocus(false);
    }, []);
    return (_jsx(BKJPillSelectContext.Provider, { value: {
            wrapperRef,
            inputRef,
            value,
            inputValue,
            onInputFocused,
            onInputChange,
            onInputBlur,
            onChipRemove,
            isFocused,
            setInputValue,
            uuid,
            isMaxLimitReached,
            onIsOpenChange,
        }, children: children }));
};
export const useBKJPillSelectContext = () => useContext(BKJPillSelectContext);
//# sourceMappingURL=BKJPillSelect.context.js.map